const EXPORT_STATUSES = {
  SUCCESS: 0,
  ERROR: 1,
  PENDING: 2,
};

export default EXPORT_STATUSES;
